(function () {
    'use strict';

    angular.module('thankview.recorder')
        .factory('recorderService', ['$rootScope', 'webcamService', 'uploadService', 'vidJs', '$document', '$window', function ($rootScope, webcamService, uploadService, vidJs, $document, $window) {
            var states = {
                waiting: 'waiting',
                loading: 'loading',
                activatingCamera: 'activatingCamera',
                cameraDenied: 'cameraDenied',
                beginRecording: 'beginRecording',
                recordingCountdown: 'recordingCountdown',
                recording: 'recording',
                recordingThumbnail: 'recordingThumbnail',
                uploading: 'uploading',
                uploadComplete: 'uploadComplete',
                uploadFailed: 'uploadFailed',
                reviewFailed: 'reviewFailed',
                beginReview: 'beginReview',
                reviewing: 'reviewing',
            };
            var state;
            var recording;
            var currentVideo;
            var startOffset;
            var recorderService = {};
            var playerIds = {};
            var webcamActive = false;
            var playerService = null;
            var currentId = null;

            $rootScope.$on('recorder-camera-activated', function () {
                if (state === states.activatingCamera) {
                    recorderService.setState(states.beginRecording);
                    $rootScope.$apply();
                }
            });
            $rootScope.$on('recorder-camera-denied', function () {
                if (state === states.activatingCamera) {
                    recorderService.setState(states.cameraDenied);
                    $rootScope.$apply();
                }
            });
            $rootScope.$on('recorder-start-countdown', function () {
                if (state === states.beginRecording) {
                    recorderService.setState(states.recordingCountdown);
                }
            });
            $rootScope.$on('recorder-start-recording', function () {
                if (state === states.beginRecording) {
                    recorderService.setState(states.recording);
                    $rootScope.$apply();
                }
            });
            $rootScope.$on('recorder-select-thumbnail', function () {
                if (state === states.recording) {
                    recorderService.setState(states.recordingThumbnail);
                }
            });
            $rootScope.$on('recorder-uploading', function ($event, uploadPercentage, id) {
                if (state === states.recording) {
                    recorderService.setState(states.uploading, id);
                }
            });
            $rootScope.$on('recorder-upload-failed', function () {
                recorderService.setState(states.uploadFailed);
            });
            $rootScope.$on('recorder-upload-complete', function ($event, r, id) {
                recording = r;
                recorderService.setState(states.uploadComplete, id);
            });
            $rootScope.$on('recorder-update-video', function ($event, video) {
                if (state === states.beginReview) {
                    recorderService.review.load(video);
                }
            });

            /*
             * initializes recorder for uploading and reviewing.
             * automatically initialized by recorder.js
             * Also detects which player to use for review, video.js or jwplayer
             */
            recorderService.init = function (videoId, videoReviewId) {
                playerIds.recorder = videoId;
                playerIds.reviewer = videoReviewId;
                playerService = vidJs;

                recorderService.setState(states.waiting);
            };

            /*
             * initializes recorder for webcam
             * automatically initialized by recorder.js for desktop devices
             */
            recorderService.initWebcamService = function () {
                $rootScope.webcamSupport = !!$window.MediaRecorder;
                if (!$rootScope.webcamSupport) {
                    return;
                }

                webcamService.init(playerIds.recorder);
            };

            /*
             * Indicates if recorder service is initiated
             */
            recorderService.getPlayerService = function () {
                return playerService;
            };

            /**
             * Completely resets to initial waiting state
             */
            recorderService.reset = function () {
                webcamActive = false;

                recorderService.stopVideos();

                recorderService.setState(states.waiting);
            };

            /**
             * Will set back to 'beginRecording' if webcam is active,
             * otherwise sets the state back to waiting
             */
            recorderService.rerecord = function () {
                if (webcamActive) {
                    recorderService.webcam.rerecord();
                } else {
                    recorderService.reset();
                }
            };

            /**
             * Stops all videos from playing
             */
            recorderService.stopVideos = function () {
                // shouldn't be any players if we're in reviewFailed state, or there is no player service
                if (state === states.reviewFailed || playerService === null) {
                    return;
                }

                playerService.stop();
            };

            /**
             * Get the current state of the recorder
             */
            recorderService.getState = function () {
                return state;
            };

            recorderService.setCurrentId = function (id) {
                currentId = id;
            };

            recorderService.getCurrentId = function () {
                return currentId;
            };

            /**
             * Manually sets the state,
             * this should be controlled by the other methods
             */
            recorderService.setState = function (s, id) {
                if (state === s) {
                    return;
                }

                // If the current video is not the one receiving the state update, ignore it
                if (id && (currentId !== id)) {
                    return;
                }

                // don't change stats if it failed and we're trying to review the video
                if (state === states.reviewFailed && s === states.beginReview) {
                    return;
                }

                console.log('recorder state', s);

                state = s;
                $rootScope.$broadcast('recorder-state-change', state);
            };

            /**
             * Get whether the webcam is currently on
             */
            recorderService.getWebcamActive = function () {
                return webcamActive;
            };

            /**
             * Bind on when the recorder state is changed
             */
            recorderService.onStateChange = function (callback) {
                $rootScope.$on('recorder-state-change', function () {
                    callback(state);
                });
            };

            /**
             * After a webcam recording is complete,
             * retrieve the data for the recording
             */
            recorderService.getRecording = function () {
                return recording;
            };

            recorderService.fileUploader = {};
            recorderService.fileUploader.open = function () {
                $rootScope.$broadcast('recorder-open-uploader');
            };

            recorderService.fileUploader.upload = function (e) {
                uploadService.uploadFile(e);

                recorderService.setState(states.uploading);
            };

            /**
             * Reupload a file that has failed uploading
             */
            recorderService.fileUploader.reUpload = function () {
                if (state === 'uploadFailed') {
                    uploadService.reUploadFile();
                    recorderService.setState(states.uploading);
                }
            };

            recorderService.webcam = {};

            /**
             * Turn on webcam
             */
            recorderService.webcam.open = function () {
                webcamActive = true;

                recorderService.setState(states.activatingCamera);

                webcamService.initRecorder();
            };

            /**
             * Reset the webcam to 'beginRecording' state
             */
            recorderService.webcam.rerecord = function () {
                recorderService.webcam.open();
            };

            recorderService.webcam.getResolutions = function () {
                return webcamService.getResolutions();
            };

            recorderService.webcam.getInternalResolutions = function () {
                return webcamService.getInternalResolutions();
            };

            recorderService.webcam.setResolution = function (resolution) {
                webcamService.setResolution(resolution);
            };

            recorderService.webcam.setInternalResolution = function (resolution) {
                webcamService.setInternalResolution(resolution);
            };

            recorderService.webcam.setCamera = function (device) {
                webcamService.setCamera(device);
            };

            recorderService.webcam.setAudio = function (device) {
                webcamService.setAudio(device);
            };

            recorderService.webcam.startRecording = function () {
                if (webcamService) webcamService.startRecorder();
            };

            recorderService.webcam.stopRecording = function (id) {
                if (webcamService) webcamService.stopRecorder(id);
            };

            recorderService.webcam.startOver = function () {
                if (webcamService) webcamService.startOver();
                recorderService.setState(states.beginRecording);
            };

            recorderService.review = {};

            /**
             * Load a video and immediately start the review state
             */
            recorderService.review.load = function (video) {
                if (video) {
                    currentVideo = video;
                    $rootScope.$broadcast('recorder-load-video');
                }

                recorderService.review.loadPlayer();
            };

            /**
             * Reset review state. The current video loaded will be ready for review
             */
            recorderService.review.reload = function () {
                if (typeof currentVideo.onComplete !== 'function') {
                    recorderService.review.loadPlayer();
                } else {
                    currentVideo.onComplete();
                }
            };

            /**
             * Loads the video into video.js
             */
            recorderService.review.loadPlayer = function () {
                recorderService.setState(states.loading);

                startOffset = currentVideo.video_untrimmed ? 0 : currentVideo.start_trim;

                // set state to review video
                if (!currentVideo.auto_start) {
                    recorderService.setState(states.beginReview);
                } else {
                    recorderService.setState(states.reviewing);
                }

                var options = {
                    thumbnail: currentVideo.video_thumb || currentVideo.image,
                    captions: currentVideo.caption_url,
                    autoplayCaptions: currentVideo.autoplay_captions,
                };

                var idTarget = null;
                var videoElement = null;
                if (playerService === vidJs) {
                    playerService.close(playerIds.reviewer);
                    idTarget = playerIds.reviewer;
                    videoElement = $document[0].querySelector('#' + playerIds.reviewer + '-wrapper');
                    playerService.init(idTarget, currentVideo.video_path, videoElement, options);
                } else {
                    idTarget = playerIds.reviewer + '-wrapper';
                    var playerLoaded = playerService.init(idTarget, currentVideo.video_path, { image: options.thumbnail }, options.captions);
                    playerLoaded.catch(function () {
                        recorderService.setState(states.reviewFailed);
                        $rootScope.$apply();
                    });
                }

                // set to review failed if video isn't playable
                playerService.onError(function () {
                    var error = playerService.getError();

                    if (error.code === 3 || error.code === 4) {
                        // unsupported video format error
                    } else if ($window.Bugsnag) {
                        Bugsnag.notify(new Error('Video JS Error ' + error.message));
                    }

                    recorderService.setState(states.reviewFailed);
                    $rootScope.$apply();
                });

                playerService.onReady(function () {
                    if (currentVideo.auto_start) {
                        playerService.play();
                    }
                });

                playerService.onFirstFrame(function () {
                    if (startOffset > 0) {
                        playerService.seek(startOffset);
                    }
                });

                playerService.onPlay(function () {
                    recorderService.setState(states.reviewing);
                    $rootScope.$apply();
                });

                playerService.onTime(function (time) {
                    if (time.position < startOffset) {
                        playerService.seek(startOffset + 0.01);
                    }

                    if (currentVideo.end_trim && !currentVideo.video_untrimmed) {
                        if (time.position >= currentVideo.end_trim - 0.01 && !currentVideo.final_video && time.position < time.duration) {
                            playerService.resetVideo();
                            recorderService.setState(states.beginReview);
                            $rootScope.$apply();
                        }
                    }
                });

                playerService.onComplete(function () {
                    playerService.resetVideo();
                    recorderService.setState(states.beginReview);
                    $rootScope.$apply();
                });
            };

            /**
             * Return the current video in review state
             */
            recorderService.review.getVideo = function () {
                return currentVideo;
            };

            return recorderService;
        }]);
}());
